import {MutableRefObject, useCallback, useRef} from 'react';
import {ProblemCollectionPreview} from '@types';
import {getCollectionTypeColor} from '@utils/const/collection';

export default function useColorManager() {
    const colorCache: MutableRefObject<{[p: string]: string}> = useRef<{
        [key: string]: string;
    }>({});

    const getColorFor = useCallback(
        (item: ProblemCollectionPreview): string => {
            if (!colorCache.current[item.group]) {
                colorCache.current[item.group] = getCollectionTypeColor(
                    item.group
                );
            }
            return colorCache.current[item.group];
        },
        []
    );

    return {getColorFor, colorCache};
}
